document.addEventListener('DOMContentLoaded', function () {

  /* ------------------------------------------------------------------
     Sticky top stack: measure height + toggle solid background on scroll
     ------------------------------------------------------------------ */
  var topbar = document.querySelector('[data-site-topbar]');
  var header = document.querySelector('[data-site-header]');

  function setTopbarHeightVar() {
    if (!topbar) return;
    document.documentElement.style.setProperty('--topbar-height', topbar.offsetHeight + 'px');
  }
  setTopbarHeightVar();
  window.addEventListener('resize', setTopbarHeightVar);
  window.addEventListener('load', setTopbarHeightVar);

  var menuIsOpen = false;
  function updateHeaderScrollState() {
    if (!header) return;
    var shouldBeSolid = window.scrollY > 40 || menuIsOpen;
    header.classList.toggle('is-scrolled', shouldBeSolid);
  }
  window.addEventListener('scroll', updateHeaderScrollState, { passive: true });
  updateHeaderScrollState();

  /* ------------------------------------------------------------------
     Cart count badge — shared by quick-add, the PDP form and anything
     else that adds to cart via AJAX.
     ------------------------------------------------------------------ */
  var cartCountEls = document.querySelectorAll('[data-cart-count]');
  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ------------------------------------------------------------------
     Mobile menu toggle (header button + in-panel close button)
     ------------------------------------------------------------------ */
  var menuToggles = document.querySelectorAll('[data-menu-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');

  function closeNav() {
    if (!siteNav || !siteNav.classList.contains('is-open')) return;
    siteNav.classList.remove('is-open');
    menuIsOpen = false;
    document.body.classList.remove('nav-open');
    menuToggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    updateHeaderScrollState();
  }

  if (menuToggles.length && siteNav) {
    menuToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = siteNav.classList.toggle('is-open');
        menuIsOpen = isOpen;
        document.body.classList.toggle('nav-open', isOpen);
        menuToggles.forEach(function (t) {
          t.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
        updateHeaderScrollState();
        if (isOpen) closeSearch();
      });
    });
  }

  /* ------------------------------------------------------------------
     Search drawer: opens from the header search icon, closes the nav
     if it's open, and shows live predictive results as you type.
     ------------------------------------------------------------------ */
  var searchToggles = document.querySelectorAll('[data-search-toggle]');
  var searchDrawer = document.querySelector('[data-search-drawer]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');

  function closeSearch() {
    if (!searchDrawer || !searchDrawer.classList.contains('is-open')) return;
    searchDrawer.classList.remove('is-open');
    searchToggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }

  if (searchToggles.length && searchDrawer) {
    searchToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = searchDrawer.classList.toggle('is-open');
        searchToggles.forEach(function (t) { t.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); });
        if (isOpen) {
          closeNav();
          if (searchInput) setTimeout(function () { searchInput.focus(); }, 60);
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });
    document.addEventListener('click', function (e) {
      if (!searchDrawer.classList.contains('is-open')) return;
      var isToggle = e.target.closest('[data-search-toggle]');
      var insideDrawer = e.target.closest('[data-search-drawer]');
      if (!isToggle && !insideDrawer) closeSearch();
    });
  }

  if (searchInput && searchResults) {
    var searchDebounce;
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchDebounce);
      if (q.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchDebounce = setTimeout(function () { runPredictiveSearch(q); }, 300);
    });
  }

  function runPredictiveSearch(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,vendor';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          searchResults.innerHTML = '<p class="search-drawer__empty">Nessun risultato per &ldquo;' + escapeHtml(q) + '&rdquo;</p>';
          return;
        }
        var html = products.map(function (p) {
          var img = p.featured_image ? p.featured_image.url : '';
          return '<a class="search-result" href="' + p.url + '">' +
            (img ? '<img src="' + img + '&width=140" alt="" loading="lazy">' : '<span class="search-result__ph"></span>') +
            '<span class="search-result__meta">' +
              '<span class="search-result__title">' + escapeHtml(p.title) + '</span>' +
              '<span class="search-result__price">' + p.price + '</span>' +
            '</span>' +
          '</a>';
        }).join('');
        html += '<a class="search-drawer__view-all" href="/search?q=' + encodeURIComponent(q) + '">Vedi tutti i risultati &rarr;</a>';
        searchResults.innerHTML = html;
      })
      .catch(function () {});
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------------
     Scroll reveal: fade/slide elements in as they enter the viewport.
     Exposed as a function so content injected later (related products)
     can opt back in.
     ------------------------------------------------------------------ */
  function initReveal(root) {
    var revealTargets = root.querySelectorAll('[data-animate]:not(.is-reveal-bound)');
    if (!revealTargets.length) return;

    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });

      revealTargets.forEach(function (el, i) {
        el.classList.add('is-reveal-bound');
        el.style.setProperty('--reveal-delay', Math.min(i % 4, 3) * 90 + 'ms');
        revealObserver.observe(el);
      });
    } else {
      revealTargets.forEach(function (el) {
        el.classList.add('is-reveal-bound', 'is-visible');
      });
    }
  }
  initReveal(document);

  /* ------------------------------------------------------------------
     Carousels: native scroll-snap track driven by prev/next arrows,
     with an optional hairline "line counter" showing position. Exposed
     as a function so content injected later (related products) can
     initialize its own carousel.
     ------------------------------------------------------------------ */
  function initCarousels(root) {
    root.querySelectorAll('[data-carousel]:not(.is-carousel-bound)').forEach(function (carousel) {
      carousel.classList.add('is-carousel-bound');
      var track = carousel.querySelector('[data-carousel-track]');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var lineWrap = carousel.querySelector('[data-carousel-line]');
      var lineFill = lineWrap ? lineWrap.querySelector('.carousel-line__fill') : null;
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;

      if (lineFill) {
        lineFill.style.width = (100 / slides.length) + '%';
      }

      function activeIndex() {
        var trackLeft = track.scrollLeft;
        var closest = 0;
        var closestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - trackLeft);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        return closest;
      }

      function syncLine() {
        if (!lineFill) return;
        var idx = activeIndex();
        lineFill.style.transform = 'translateX(' + (idx * 100) + '%)';
      }
      syncLine();
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(syncLine);
      }, { passive: true });

      function scrollByOne(direction) {
        var idx = activeIndex();
        var target = slides[idx + direction];
        if (!target) {
          target = direction > 0 ? slides[0] : slides[slides.length - 1];
        }
        target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByOne(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByOne(1); });

      var autoplayMs = parseInt(carousel.getAttribute('data-carousel-autoplay') || '0', 10);
      if (autoplayMs > 0) {
        var timer = null;
        function startAutoplay() {
          stopAutoplay();
          timer = setInterval(function () { scrollByOne(1); }, autoplayMs);
        }
        function stopAutoplay() {
          if (timer) clearInterval(timer);
        }
        startAutoplay();
        ['mouseenter', 'touchstart', 'focusin'].forEach(function (evt) {
          carousel.addEventListener(evt, stopAutoplay);
        });
        ['mouseleave', 'touchend', 'focusout'].forEach(function (evt) {
          carousel.addEventListener(evt, startAutoplay);
        });
      }
    });
  }
  initCarousels(document);

  /* ------------------------------------------------------------------
     Hero scroll cue: nudge the page down by one viewport height
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-scroll-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      window.scrollBy({ top: window.innerHeight - 120, behavior: 'smooth' });
    });
  });

  /* ------------------------------------------------------------------
     Product gallery thumbnails
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var wrapper = thumb.closest('[data-product-gallery]');
      if (!wrapper) return;
      var mainImg = wrapper.querySelector('[data-product-main-image]');
      var newSrc = thumb.getAttribute('data-full-src');
      if (mainImg && newSrc) {
        mainImg.src = newSrc;
      }
      wrapper.querySelectorAll('[data-product-thumb]').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });

  /* ------------------------------------------------------------------
     Variant picker: track selected option values per product form and
     resolve them to the matching variant id via the hidden <select>.
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var form = wrapper.querySelector('form');
    if (!form) return;
    var optionGroups = wrapper.querySelectorAll('[data-option-buttons]');
    var variantSelect = wrapper.querySelector('[data-variant-select]');
    var submitButton = wrapper.querySelector('button[type="submit"]');
    if (!variantSelect) return;

    var selected = [];
    optionGroups.forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      var activeBtn = group.querySelector('.swatch.is-selected') || group.querySelector('[data-option-value]');
      selected[index] = activeBtn ? activeBtn.getAttribute('data-option-value') : null;
    });

    function updateVariant() {
      var match = null;
      variantSelect.querySelectorAll('option').forEach(function (opt) {
        var optValues = (opt.getAttribute('data-options') || '').split('||');
        var isMatch = optValues.every(function (val, i) { return selected[i] === val; });
        if (isMatch) match = opt;
      });

      if (match) {
        variantSelect.value = match.value;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        if (submitButton) {
          submitButton.disabled = match.hasAttribute('data-unavailable');
          submitButton.textContent = match.hasAttribute('data-unavailable')
            ? submitButton.getAttribute('data-sold-out-label') || submitButton.textContent
            : submitButton.getAttribute('data-add-label') || submitButton.textContent;
        }
      } else if (submitButton) {
        submitButton.disabled = true;
      }
    }

    optionGroups.forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      group.querySelectorAll('[data-option-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.hasAttribute('disabled')) return;
          group.querySelectorAll('[data-option-value]').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          selected[index] = btn.getAttribute('data-option-value');
          updateVariant();
        });
      });
    });
  });

  /* ------------------------------------------------------------------
     Quantity steppers
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-quantity-selector]').forEach(function (selector) {
    var input = selector.querySelector('input[type="number"]');
    var minus = selector.querySelector('[data-quantity-minus]');
    var plus = selector.querySelector('[data-quantity-plus]');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function () {
        var value = parseInt(input.value || '1', 10);
        value = Math.max(1, value - 1);
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var value = parseInt(input.value || '1', 10);
        input.value = value + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  /* ------------------------------------------------------------------
     Quick add: add a product's first available variant to the cart
     via the AJAX Cart API without leaving the page.
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-quick-add]').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId || button.hasAttribute('disabled')) return;

      var routes = window.themeRoutes || {};
      var originalLabel = button.textContent;
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = '...';

      fetch(routes.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.data && result.data.description ? result.data.description : 'Errore');
          return fetch(routes.cart || '/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.textContent = button.getAttribute('data-added-label') || 'Aggiunto ✓';
          setTimeout(function () {
            button.classList.remove('is-added');
            button.textContent = originalLabel;
            button.disabled = false;
          }, 1800);
        })
        .catch(function () {
          button.classList.remove('is-loading');
          button.textContent = 'Errore';
          setTimeout(function () {
            button.textContent = originalLabel;
            button.disabled = false;
          }, 1800);
        });
    });
  });

  /* ------------------------------------------------------------------
     Product page: add to cart via AJAX instead of a full page reload,
     mirroring the quick-add feedback state on the same button.
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-form] form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitButton = form.querySelector('button[type="submit"]');
      if (!submitButton || submitButton.disabled) return;

      var routes = window.themeRoutes || {};
      var originalLabel = submitButton.getAttribute('data-add-label') || submitButton.textContent;
      submitButton.disabled = true;
      submitButton.classList.add('is-loading');
      submitButton.textContent = '...';

      fetch(routes.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.data && result.data.description ? result.data.description : 'Errore');
          return fetch(routes.cart || '/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          submitButton.classList.remove('is-loading');
          submitButton.classList.add('is-added');
          submitButton.textContent = 'Aggiunto al carrello ✓';
          setTimeout(function () {
            submitButton.classList.remove('is-added');
            submitButton.textContent = originalLabel;
            submitButton.disabled = false;
          }, 2000);
        })
        .catch(function () {
          submitButton.classList.remove('is-loading');
          submitButton.textContent = 'Errore, riprova';
          setTimeout(function () {
            submitButton.textContent = originalLabel;
            submitButton.disabled = false;
          }, 2000);
        });
    });
  });

  /* ------------------------------------------------------------------
     Related products: fetched from Shopify's recommendations endpoint
     and injected once the product id is known, then re-initialized.
     ------------------------------------------------------------------ */
  var relatedWrap = document.querySelector('[data-related-products]');
  if (relatedWrap) {
    var relatedProductId = relatedWrap.getAttribute('data-product-id');
    if (relatedProductId) {
      fetch('/recommendations/products.json?product_id=' + relatedProductId + '&limit=8&section_id=related-products')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.sections && data.sections['related-products']) {
            relatedWrap.innerHTML = data.sections['related-products'];
            initCarousels(relatedWrap);
            initReveal(relatedWrap);
          }
        })
        .catch(function () {});
    }
  }
});